'use client';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
// import Button from "@mui/material/Button";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useUserContext } from '../contexts/UserContext';
import * as _ from 'lodash';
import Cookies from 'js-cookie';
import {
  MagnifyingGlassIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
} from '@heroicons/react/24/outline';
import mqtt from 'mqtt';
import { ResponsiveContainer, ScatterChart, XAxis, YAxis, Tooltip, Scatter, CartesianGrid, Rectangle } from 'recharts';
import { set } from 'date-fns';

let signalstopic = 'goldensparrowcapital-signals';

const Symbols = props => {
  const {
    user
  } = useUserContext();

  const [section, setSection] = useState('Active')
  const [client, setClient] = useState(null);
  const mqttClientRef = useRef(null); // holds the MQTT client instance
  const mqttListenerAttached = useRef(false); // ensures only one message handler is attached
  const wsRefBinance = useRef(null);
  const [lastUpdated, setLastUpdated] = useState(new Date().valueOf());
  const [isProcessing, setIsProcessing] = useState(false)
  const [symbols, setSymbols] = useState([])
  const [whaleAccumulationData, setWhaleAccumulationData] = useState([])
  const [fvgData, setFvgData] = useState([])
  const [bbDataLowest, setBBDataLowest] = useState([])
  const [bbDataHighest, setBBDataHighest] = useState([])
  const [heavyBuying, setHeavyBuying] = useState([])
  const [heavySelling, setHeavySelling] = useState([])
  const [recentlyViewed, setRecentlyViewed] = useState([])
  const [candleCloseBelowBBLower, setCandleCloseBelowBBLower] = useState([])

  const addIntoRecentlyViewed = (symbol) => {
    //check if symbol already exists in recentlyViewed
    setRecentlyViewed((prev) => {
      const updated = [...prev];
      const index = updated.findIndex((item) => item.symbol === symbol);
      if (index == -1) {
        //add it to the recentlyViewed
        //use push
        updated.push({ symbol, creationDate: Date.now() });
      }
      return updated;
    });
  };

  const removeFromRecentlyViewed = (symbol) => {
    setRecentlyViewed((prev) => {
      const updated = [...prev];
      const index = updated.findIndex((item) => item.symbol === symbol);
      if (index !== -1) {
        updated.splice(index, 1);
      }
      return updated;
    });
  };

  // Render a bubble sized by tradeSize and colored by side
  const renderWhale = (props) => {
    const { cx, cy, payload } = props;
    if (cx === undefined || cy === undefined) return null;
    const side = (payload.side || '').toUpperCase();
    const baseSize = Number(payload.raw?.size || payload.size || 1);
    // scale radius: sqrt makes large sizes manageable
   // const radius = Math.max(2, Math.sqrt(baseSize));
     const radius =4
    const fill = side === 'BUY' ? '#2ECC71' : side === 'SELL' ? '#FF4136' : '#8884d8';
    return (
      <circle cx={cx} cy={cy} r={radius} fill={fill} fillOpacity={0.8}
      // stroke="#222" strokeWidth={0.5} 
      />
    );
  };

  // Render a triangle sized by tradeSize and colored by side
  const renderFVG = (props) => {
    const { cx, cy, payload } = props;
    if (cx === undefined || cy === undefined) return null;
    const side = (payload.side || '').toUpperCase();
    const timeFrame = payload.timeFrame || null;
    const fill = side === 'BULLISH' ? '#2ECC71' : side === 'BEARISH' ? '#ff0000' : '#949496ff';
    //the timeFrame should appear inside the <polygon>

    // ensure polygon is at least 5px wide (scales with payload size if available)
    const rawSize = Number(payload?.raw?.size || payload?.size || 0);
    // tame very large sizes with sqrt; scale up by ~4 (was 2) to make triangles ~2x larger, increase max clamp
    const widthPx = Math.max(10, Math.min(120, Math.sqrt(Math.max(1, rawSize)) * 4));
    const half = widthPx / 2;
    // upward-pointing isosceles triangle centered at (cx, cy)
    const points = `${cx},${cy - half} ${cx - half},${cy + half} ${cx + half},${cy + half}`;
    return (
      <polygon points={points} fill={fill} fillOpacity={0.5}
      // stroke="#222" strokeWidth={1}
      >
        {timeFrame && <title>{timeFrame}</title>}
      </polygon>
    );


  };

  // Render a square sized and colored by side
  const renderBBGapLowest = (props) => {
    const { cx, cy, payload } = props;
    if (cx === undefined || cy === undefined) return null;
    const side = (payload.side || '').toUpperCase();
    const timeFrame = payload.timeFrame || null;
    const fill = side === 'BULLISH' ? '#ff0400ff' : side === 'BEARISH' ? '#ff0000' : '#949496ff';
    //the timeFrame should appear inside the <polygon>

    // ensure polygon is at least 5px wide (scales with payload size if available)
    const rawSize = Number(payload?.raw?.size || payload?.size || 0);
    // tame very large sizes with sqrt; scale up by ~4 (was 2) to make triangles ~2x larger, increase max clamp
    const widthPx = Math.max(10, Math.min(120, Math.sqrt(Math.max(1, rawSize)) * 4));
    const half = widthPx / 2;
    // upward-pointing isosceles triangle centered at (cx, cy)
    const points = `${cx},${cy - half} ${cx - half},${cy + half} ${cx + half},${cy + half}`;
    return (
      <Rectangle x={cx - half} y={cy - half} width={widthPx} height={widthPx} fill={fill} fillOpacity={.5}
      //stroke="#222" strokeWidth={1}
      >
        {timeFrame && <title>{timeFrame}</title>}
      </Rectangle>
    );
  };

  // Render a square sized and colored by side
  const renderBBGapHighest = (props) => {
    const { cx, cy, payload } = props;
    if (cx === undefined || cy === undefined) return null;
    const side = (payload.side || '').toUpperCase();
    const timeFrame = payload.timeFrame || null;
    const fill = side === 'BULLISH' ? '#05c32eff' : side === 'BEARISH' ? '#ff0000' : '#949496ff';
    //the timeFrame should appear inside the <polygon>

    // ensure polygon is at least 5px wide (scales with payload size if available)
    const rawSize = Number(payload?.raw?.size || payload?.size || 0);
    // tame very large sizes with sqrt; scale up by ~4 (was 2) to make triangles ~2x larger, increase max clamp
    const widthPx = Math.max(10, Math.min(120, Math.sqrt(Math.max(1, rawSize)) * 4));
    const half = widthPx / 2;
    // upward-pointing isosceles triangle centered at (cx, cy)
    const points = `${cx},${cy - half} ${cx - half},${cy + half} ${cx + half},${cy + half}`;
    return (
      <Rectangle x={cx - half} y={cy - half} width={widthPx} height={widthPx} fill={fill} fillOpacity={.5}
      //stroke="#222" strokeWidth={1}
      >
        {timeFrame && <title>{timeFrame}</title>}
      </Rectangle>
    );
  };

  const renderHeavyBuying = (props) => {
    const { cx, cy, payload } = props;
    if (cx === undefined || cy === undefined) return null;
    const side = (payload.side || '').toUpperCase();
    const timeFrame = payload.timeFrame || null;
    const fill = 'green' 

    // ensure polygon is at least 5px wide (scales with payload size if available)
    const rawSize = Number(payload?.raw?.size || payload?.size || 0);
    // tame very large sizes with sqrt; scale up by ~4 (was 2) to make triangles ~2x larger, increase max clamp
    const widthPx = Math.max(10, Math.min(120, Math.sqrt(Math.max(1, rawSize)) * 4));
    const half = widthPx / 2;
    // upward-pointing isosceles triangle centered at (cx, cy)
    const points = `${cx},${cy - half} ${cx - half},${cy + half} ${cx + half},${cy + half}`;
    return (
      // i want a dash and not polygon
      <line x1={cx - half} y1={cy} x2={cx + half} y2={cy} stroke={fill} strokeWidth={1} fillOpacity={1}/>
    );
  };

  const renderHeavySelling = (props) => {
    const { cx, cy, payload } = props;
    if (cx === undefined || cy === undefined) return null;
    const side = (payload.side || '').toUpperCase();
    const timeFrame = payload.timeFrame || null;
    const fill = "red"

    // ensure polygon is at least 5px wide (scales with payload size if available)
    const rawSize = Number(payload?.raw?.size || payload?.size || 0);
    // tame very large sizes with sqrt; scale up by ~4 (was 2) to make triangles ~2x larger, increase max clamp
    const widthPx = Math.max(10, Math.min(120, Math.sqrt(Math.max(1, rawSize)) * 4));
    const half = widthPx / 2;
    // upward-pointing isosceles triangle centered at (cx, cy)
    const points = `${cx},${cy - half} ${cx - half},${cy + half} ${cx + half},${cy + half}`;
    return (
       <line x1={cx - half} y1={cy} x2={cx + half} y2={cy} stroke={fill} strokeWidth={1} fillOpacity={1}/>
    );
  };

  const renderCandleCloseBelowBBLower = (props) => {
    const { cx, cy, payload } = props;
    if (cx === undefined || cy === undefined) return null;
    const side = (payload.side || '').toUpperCase();
    const baseSize = Number(payload.raw?.size || payload.size || 1);
    // scale radius: sqrt makes large sizes manageable
    const radius = Math.max(2, Math.sqrt(baseSize));
    const fill = "#000";
    return (
      <circle cx={cx} cy={cy} r={radius} fill={fill} fillOpacity={1} 
      // stroke="#222" strokeWidth={0.5} 
      />
    );
  };

  const TooltipBox = ({ active, payload }) => {
    if (!active || !payload || !payload.length) return null;
    const p = payload[0].payload;
    return (
      <div style={{ background: '#000', padding: 8, border: '1px solid #ddd' }}>
        <div style={{ fontSize: 12, fontWeight: '600' }}>{p.raw?.symbol || ''}</div>
        <div style={{ fontSize: 12 }}>{p.raw?.metricName || ''}</div>

        <div style={{ fontSize: 12 }}>{new Date(p.x).toLocaleString()}</div>
        <div style={{ fontSize: 12 }}>Price: {p.y}</div>
        {p.raw?.timeFrame && (
          <div style={{ fontSize: 12 }}>Time Frame: {p.raw.timeFrame}</div>
        )}
        {(p.raw?.size || p.size) && (
          <div style={{ fontSize: 12 }}>Size: {p.raw?.size ?? p.raw?.size ?? p.size}</div>
        )}
        <div style={{ fontSize: 12 }}>Side: {p.side}</div>
      </div>
    );
  };

  const [sidePanel, setSidePanel] = useState({
    visible: false,
    symbol: null,
    lastUpdated: new Date().valueOf(),
    strategies: [],
    metrics: []
  })


  //connect and subscribe to MQTT broker
  const _connectMQTT = useCallback(async (props) => {
    if (mqttClientRef.current) return; // already connected
    let clientID = 'GoldenSparrowCapital-' + user.user_uuid;
    const gsccookie = Cookies.get('gsccookie') || null;
    const newClient = mqtt.connect(process.env.REACT_APP_EXTERNAL_MQTT_SERVER_URL, {
      clientId: clientID,
      username: 'user-jwt',
      password: gsccookie,
      clean: true,
      rejectUnauthorized: true,
      reconnectPeriod: 60000,
    });
    mqttClientRef.current = newClient;
    setClient(newClient);

    newClient.on('connect', async () => {
      console.log('Connected to MQTT:', new Date().toLocaleTimeString());
      //many a times the following GET_WATCHERS is published multiple times, which creates a problem
      //can u fix
      //how will the following fix it ?

      [
        'RECEIVE_SYMBOLS_WEB',
        'RECEIVE_SYMBOL_STRATEGIES_AND_METRICS_WEB'
      ].forEach(topic => {
        newClient.unsubscribe(topic);
        newClient.subscribe(topic, err => {
          if (err) {
            console.error('Topic Subscribe error', err);
          }
        });
      });
    });
  }, [setClient, setIsProcessing]);

  //i want publishGetSymbols() to be called every 5 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      publishGetSymbols();
      if (sidePanel.visible) {
        publishGetSymbolData(sidePanel.symbol);
      }
    }, 1 * 60 * 1000); // 1 minutes
    return () => clearInterval(interval);
  }, [client, sidePanel]);

  useEffect(() => {
    if (!client || mqttListenerAttached.current) return;
    const handler = (topic, message) => {
      //  console.log('Received Topic:', topic, new Date().toLocaleTimeString());
      if (topic === 'RECEIVE_SYMBOLS_WEB') {
        let mm = JSON.parse(message);
        //  console.log("Symbols:", mm.symbols)

        setSymbols(prev => [...mm.symbols]);
        setLastUpdated(new Date().valueOf());
      }
      if (topic === 'RECEIVE_SYMBOL_STRATEGIES_AND_METRICS_WEB') {
        let mm = JSON.parse(message);
        console.log("Strategies and Metrics:", mm)

        setSidePanel(prev => ({
          ...prev,
          strategies: mm.strategies || [],
          metrics: mm.metrics || [],
          lastUpdated: Date.now(),
        }));
        // Map metrics into chart-friendly points: x = timestamp, y = currentPrice, size = tradeSize
        const WHALE_ACCUMULATION_DATA = (mm.metrics || [])
          .filter(item => item.metricName === 'WHALE_ACCUMULATION')
          .map(item => ({
            x: new Date(item.creationDate).getTime(),
            y: Number(item.currentPrice ?? item.price) || 0,
            size: Number(item.tradeSize) || 1,
            side: (item.side || '').toUpperCase(),
            raw: item,
          }));
        setWhaleAccumulationData(WHALE_ACCUMULATION_DATA);

        const FVG_DATA = (mm.metrics || [])
          .filter(item => item.metricName === 'FVG')
          .map(item => ({
            x: new Date(item.creationDate).getTime(),
            y: Number(item.currentPrice ?? item.price) || 0,
            side: (item.side || '').toUpperCase(),
            timeFrame: item.timeFrame || null,
            raw: item,
          }));
        setFvgData(FVG_DATA);
        const BBGAP_DATA_LOWEST = (mm.metrics || [])
          .filter(item => item.metricName === 'BBGAP_LOWEST')
          .map(item => ({
            x: new Date(item.creationDate).getTime(),
            y: Number(item.currentPrice ?? item.price) || 0,
            side: (item.side || '').toUpperCase(),
            timeFrame: item.timeFrame || null,
            raw: item,
          }));
        setBBDataLowest(BBGAP_DATA_LOWEST);
       
        const BBGAP_DATA_HIGHEST = (mm.metrics || [])
          .filter(item => item.metricName === 'BBGAP_HIGHEST')
          .map(item => ({
            x: new Date(item.creationDate).getTime(),
            y: Number(item.currentPrice ?? item.price) || 0,
            side: (item.side || '').toUpperCase(),
            timeFrame: item.timeFrame || null,
            raw: item,
          }));
        setBBDataHighest(BBGAP_DATA_HIGHEST);

        const HEAVY_BUYING = (mm.metrics || [])
          .filter(item => item.metricName === 'HEAVY_BUYER_DETECTED')
          .map(item => ({
            x: new Date(item.creationDate).getTime(),
            y: Number(item.currentPrice ?? item.price) || 0,
            side: (item.side || '').toUpperCase(),
            timeFrame: item.timeFrame || null,
            raw: item,
          }));
        setHeavyBuying(HEAVY_BUYING);

        const HEAVY_SELLING = (mm.metrics || [])
          .filter(item => item.metricName === 'HEAVY_SELLER_DETECTED')
          .map(item => ({
            x: new Date(item.creationDate).getTime(),
            y: Number(item.currentPrice ?? item.price) || 0,
            side: (item.side || '').toUpperCase(),
            timeFrame: item.timeFrame || null,
            raw: item,
          }));
        setHeavySelling(HEAVY_SELLING);

         const CANDLE_CLOSED_BELOW_BBLOWER = (mm.metrics || [])
          .filter(item => item.metricName === 'CANDLE_CLOSED_BELOW_BBLOWER')
          .map(item => ({
            x: new Date(item.creationDate).getTime(),
            y: Number(item.currentPrice ?? item.price) || 0,
            side: (item.side || '').toUpperCase(),
            timeFrame: item.timeFrame || null,
            raw: item,
          }));
        setCandleCloseBelowBBLower(CANDLE_CLOSED_BELOW_BBLOWER);

      }

    };
    client.on('message', handler);
    mqttListenerAttached.current = true;
    return () => {
      if (mqttClientRef.current) {
        mqttClientRef.current.end();
        mqttClientRef.current = null;
        setClient(null);
        mqttListenerAttached.current = false;
      }
    };
  }, [client, setIsProcessing]);

  useEffect(() => {
    _connectMQTT(props);
    publishGetSymbols();
  }, []);

  const publishGetSymbols = useCallback(() => {
    const client = mqttClientRef.current;
    const gsccookie = Cookies.get('gsccookie') || null;

    const doPublish = (c) => {
      if (!c || typeof c.publish !== 'function') {
        console.error('MQTT client not available for publish');
        return;
      }
      c.publish('GET_SYMBOLS', JSON.stringify({ token: gsccookie }), err => {
        if (!err) {
          setIsProcessing(true);
          console.log('GET_SYMBOLS request published:', new Date().toLocaleTimeString());
        } else {
          console.error('Topic Publish error', err);
        }
      });
    };

    if (!client || client.disconnected) {
      // ensure a connection is attempted and publish once connected
      _connectMQTT();
      const onConnect = () => {
        const c = mqttClientRef.current;
        doPublish(c);
        if (c && typeof c.removeListener === 'function') {
          c.removeListener('connect', onConnect);
        }
      };
      // attach listener if client exists, otherwise _connectMQTT's connect handler will trigger publish when client is ready
      if (mqttClientRef.current && typeof mqttClientRef.current.on === 'function') {
        mqttClientRef.current.on('connect', onConnect);
      }
      return;
    }

    doPublish(client);
  }, [_connectMQTT, setIsProcessing]);

  const publishGetSymbolData = useCallback((symbol) => {

    setSidePanel(prev => ({
      ...prev,
      symbol: symbol,
      visible: true,
      lastUpdated: new Date().valueOf()
    }));
    const client = mqttClientRef.current;
    const gsccookie = Cookies.get('gsccookie') || null;

    const doPublish = (c) => {
      if (!c || typeof c.publish !== 'function') {
        console.error('MQTT client not available for publish');
        return;
      }
      c.publish('GET_SYMBOL_STRATEGIES_AND_METRICS', JSON.stringify({ token: gsccookie, symbol }), err => {
        if (!err) {
          setIsProcessing(true);
          console.log('GET_SYMBOL_STRATEGIES_AND_METRICS request published:', new Date().toLocaleTimeString());
        } else {
          console.error('Topic Publish error', err);
        }
      });
    };

    if (!client || client.disconnected) {
      // ensure a connection is attempted and publish once connected
      _connectMQTT();
      const onConnect = () => {
        const c = mqttClientRef.current;
        doPublish(c);
        if (c && typeof c.removeListener === 'function') {
          c.removeListener('connect', onConnect);
        }
      };
      // attach listener if client exists, otherwise _connectMQTT's connect handler will trigger publish when client is ready
      if (mqttClientRef.current && typeof mqttClientRef.current.on === 'function') {
        mqttClientRef.current.on('connect', onConnect);
      }
      return;
    }

    doPublish(client);

  }, [_connectMQTT, setIsProcessing]);


  return symbols ? (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100">

      {/* Main Page */}
      <div className="flex">
        <main className="flex-1 p-0">
          <header className="mb-6">
            <h1 className="text-2xl font-bold">Symbols</h1>
          </header>
          <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: 'gray', marginBottom: 3 }}> Last Updated: {new Date(lastUpdated).toLocaleDateString()} ,{' '}
            {new Date(lastUpdated).toLocaleTimeString()}
          </h1>
          <h1 className="text-sm" style={{ margin: 0, paddingTop: 1, color: '#fff', marginBottom: 3 }}> Count: {' '}
            {symbols.length}
          </h1>

          <div className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
            {recentlyViewed.length > 0 ?
              <h1 className="text-sm" style={{ margin: 0, paddingTop: 1, color: '#fff', marginBottom: 3, marginTop : 5 }}> Recently Viewed: </h1>
              : null}

            <div>
              {recentlyViewed.map((item, index) => (
                //display the name of each symbol in new line and also give a button to remove it from the recentlyViewed

                <div key={index} style={{display: 'flex', margin : 5, padding : 10}}>
                  
                  <h2 style={{ fontWeight: 'bold', fontSize: 14 }}>{index+1}. {item.symbol}</h2>
                  <button style={{
                    marginLeft : 10,
                    backgroundColor: '#fe0000ff',
                    fontSize: 12,
                    borderRadius: 5,
                    padding: 3,
                    alignItems: 'center', display: 'flex',

                  }}
                    onClick={() => removeFromRecentlyViewed(item.symbol)}>
                      Remove
                    </button>
                    <button
              style={{
                backgroundColor: '#7e8082ff',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                window.open(
                  'https://www.coinglass.com/tv/Binance_' + item.symbol,
                  '_blank'
                )

              }}
            >
              <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>CoinGlass</h4>
              <svg
                width="15"
                height="15"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
              >
                {/* Dark background circle matching trading terminal themes */}
                <circle cx="16" cy="16" r="16" fill="#1E222D" />

                {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                <path
                  d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                  stroke="#ffffff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />

                {/* Subtle outer border for depth */}
                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
              </svg>

            </button>
            <button
              style={{
                backgroundColor: '#7e8082ff',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                window.open(
                  'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + item.symbol,
                  '_blank'
                )

              }}
            >
              <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Trading View</h4>
              <svg
                width="20"
                height="20"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
              >
                {/* Standard Terminal Background */}
                <circle cx="16" cy="16" r="16" fill="#1E222D" />

                {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                {/* Border for UI consistency */}
                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
              </svg>
            </button>
                </div>

              ))}
            </div>
          </div>

          <table 
          style={{marginTop : 5}}
          className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg">
            <thead>
              <tr>
                <th className="py-2 px-4 border-b text-left">Symbol</th>
                <th className="py-2 px-4 border-b">Last Updated</th>
                {/* <th className="py-2 px-4 border-b">Data </th> 
                <th className="py-2 px-4 border-b">Metric Name</th>
                <th className="py-2 px-4 border-b">TimeFrame</th> */}
              </tr>
            </thead>
            <tbody>
              {
                // order by desc updatedDate using numeric timestamp to ensure proper sorting
                _.orderBy(symbols, "updatedDate", ['desc'])
                  .map((item, index) => (
                    <tr key={index}>
                      <td className="py-2 px-4 border-b flex items-center">
                        <div style={{ alignItems: 'center', display: 'flex', gap: 5 }}>
                          <h2>{index + 1}.</h2>
                          <h2 style={{ fontWeight: 'bold', fontSize: 14 }}>{item.symbol}</h2>
                          <button
                            style={{
                              backgroundColor: '#7e8082ff',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 3,
                              alignItems: 'center', display: 'flex'
                            }}
                            onClick={() => {
                              window.open(
                                'https://www.coinglass.com/tv/Binance_' + item.symbol,
                                '_blank'
                              )

                            }}
                          >
                            <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>CoinGlass</h4>
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 30 30"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                            >
                              {/* Dark background circle matching trading terminal themes */}
                              <circle cx="16" cy="16" r="16" fill="#1E222D" />

                              {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                              <path
                                d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                                stroke="#ffffff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />

                              {/* Subtle outer border for depth */}
                              <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                            </svg>

                          </button>
                          <button
                            style={{
                              backgroundColor: '#7e8082ff',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 3,
                              alignItems: 'center', display: 'flex'
                            }}
                            onClick={() => {
                              window.open(
                                'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + item.symbol,
                                '_blank'
                              )

                            }}
                          >
                            <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Trading View</h4>
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                            >
                              {/* Standard Terminal Background */}
                              <circle cx="16" cy="16" r="16" fill="#1E222D" />

                              {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                              <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                              <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                              <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                              {/* Border for UI consistency */}
                              <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                            </svg>
                          </button>
                          <button
                            style={{
                              backgroundColor: '#298f09ff',
                              fontSize: 12,
                              borderRadius: 5,
                              padding: 3,
                              alignItems: 'center', display: 'flex',

                            }}
                            onClick={async () => {
                              addIntoRecentlyViewed(item.symbol);
                              await publishGetSymbolData(item.symbol);
                            }}
                          >
                            <h5 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Show more...</h5>


                          </button>
                        </div>
                      </td>
                      <td className="py-2 px-4 border-b text-center text-xs">{new Date(item.updatedDate).toLocaleString()}</td>
                      {/* <td style={{ fontWeight: 'bold', fontSize: 14 }} className="py-2 px-4 border-b text-center text-xs">{item?.latestStrategyName}</td>

                      <td style={{ fontWeight: 'bold', fontSize: 14 }} className="py-2 px-4 border-b text-center text-xs">{item?.latestMetricName}</td>
                      <td style={{ fontWeight: 'bold', fontSize: 14 }} className="py-2 px-4 border-b text-center text-xs">
                          {item?.timeFrame}

                      </td> */}
                    </tr>
                  ))}
            </tbody>
          </table>
        </main>
      </div>

      {/* Side Panel */}
      {sidePanel.visible && (
        <div
          role="dialog"
          aria-label="Data panel"
          style={{
            position: 'fixed',
            right: 0,
            top: 0,
            bottom: 0,
            width: '1200px',
            maxWidth: '100%',
            backgroundColor: '#fff',
            borderLeft: '1px solid #eee',
            padding: 5,
            overflowY: 'auto',
            zIndex: 9999,
            boxShadow: '-4px 0 12px rgba(0,0,0,0.08)',
            transition: 'transform 180ms ease',
            willChange: 'transform',
          }}
        >

          <div style={{

            borderRadius: "5px", display: "flex",
            borderBottom: "1px solid #eee"
          }}>

            <h5 style={{ color: "black", padding: "5px", fontWeight: "bold" }}>{sidePanel.symbol}</h5>

            <button
              style={{
                backgroundColor: '#7e8082ff',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                window.open(
                  'https://www.coinglass.com/tv/Binance_' + sidePanel.symbol,
                  '_blank'
                )

              }}
            >
              <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>CoinGlass</h4>
              <svg
                width="15"
                height="15"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
              >
                {/* Dark background circle matching trading terminal themes */}
                <circle cx="16" cy="16" r="16" fill="#1E222D" />

                {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                <path
                  d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                  stroke="#ffffff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />

                {/* Subtle outer border for depth */}
                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
              </svg>

            </button>
            <button
              style={{
                backgroundColor: '#7e8082ff',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                window.open(
                  'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + sidePanel.symbol,
                  '_blank'
                )

              }}
            >
              <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Trading View</h4>
              <svg
                width="20"
                height="20"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
              >
                {/* Standard Terminal Background */}
                <circle cx="16" cy="16" r="16" fill="#1E222D" />

                {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                {/* Border for UI consistency */}
                <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
              </svg>
            </button>
            <button
              style={{
                backgroundColor: '#ff0000',
                fontSize: 12,
                borderRadius: 5,
                padding: 3,
                alignItems: 'center', display: 'flex',
                marginLeft: 5
              }}
              onClick={() => {
                setWhaleAccumulationData([]);
                setSidePanel(prev => ({
                  ...prev,
                  symbol: null,
                  visible: false,
                  strategies: [],
                  metrics: []
                }));
                setBBDataLowest([]);
                setBBDataHighest([]);
                setFvgData([]);
                setHeavyBuying([]);
                setHeavySelling([]);

              }}
            >
              <h4 style={{ fontWeight: 'bolder', color: 'white' }}>Close</h4>


            </button>

          </div>
          <span style={{ fontSize: 11, color: 'grey', marginLeft: 5 }}>
            Last Updated: {new Date(sidePanel.lastUpdated).toLocaleString()}
          </span>
          {/* <div style={{ fontSize: 12, color: 'black', marginLeft: 5, marginTop : 5 }}>
                <strong>Strategies:</strong> {sidePanel.strategies.length}
              </div>
              {
                sidePanel.strategies.length > 0 && (
                   _.orderBy(sidePanel.strategies, ['creationDate'], ['desc'])
                  .map((item, index) => (
                    <div className="text-xs" key={index} style={{ marginLeft: 5,color: 'black', }}>
                      {new Date(item.creationDate).toLocaleString()}
                      ,{item?.strategyName}
                      ,{item?.timeFrame}
                    </div>
                  ))
                )
              }
              <div style={{ fontSize: 12, color: 'black', marginLeft: 5, marginTop : 5 }}>
                <strong>Metrics:</strong> {sidePanel.metrics.length}
              </div>
              {
                sidePanel.metrics.length > 0 && (
                   _.orderBy(sidePanel.metrics, ['creationDate'], ['desc'])
                  .map((item, index) => (
                    <div className="text-xs" key={index} style={{ marginLeft: 5 ,color: 'black',}}>
                      {new Date(item.creationDate).toLocaleString()}
                      ,{item?.metricName}
                      ,{item?.timeFrame}
                    </div>
                  ))
                )
              } */}

          {/* //for the WHALE_ACCUMULATION metricName, i want to see a graph
              //which should show a bubble for each whale accumulation event, with the size of the bubble representing the size of the accumulation, and the color representing the direction (green for accumulation, red for distribution)
              //i want to see this graph for the last 30 days, and i want to be able to zoom in and out of the graph */}


          <br></br>
          <span style={{ fontSize: 10, color: 'black', marginLeft: 5 }}>
            <svg width="14" height="14" viewBox="0 0 20 20" 
            style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: 6 }} 
            aria-hidden="true" 
            focusable="false">
              <circle cx="10" cy="10" r="5" fill="grey" />
            </svg>
            WHALE_ACCUMULATION ({whaleAccumulationData.length})
          </span>
          <span style={{ fontSize: 10, color: 'black', marginLeft: 5 }}>
            <svg
              width="14"
              height="14"
              viewBox="0 0 20 20"
              style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: 6}}
              aria-hidden="true"
              focusable="false"
            >
              <polygon points="12,4 4,20 20,20" fill="grey" stroke="#222" strokeWidth="0.5" />
            </svg>
            FVG ({fvgData.length})
          </span>
          <span style={{ fontSize: 10, color: 'black', marginLeft: 5 }}>
            <svg
              width="14"
              height="14"
              viewBox="0 0 20 20"
              style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: 6 }}
              aria-hidden="true"
              focusable="false"
            >
              <rect x="3" y="3" width="14" height="14" rx="3" fill="grey" stroke="grey" strokeWidth="0.6" />
            </svg>
            BBGAP_LOWEST ({bbDataLowest.length})
          </span>
          <span style={{ fontSize: 10, color: 'black', marginLeft: 5 }}>
             <svg
              width="14"
              height="14"
              viewBox="0 0 20 20"
              style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: 6 }}
              aria-hidden="true"
              focusable="false"
            >
              <rect x="3" y="3" width="14" height="14" rx="3" fill="grey" stroke="grey" strokeWidth="0.6" />
            </svg>
            BBGAP_HIGHEST ({bbDataHighest.length})
          </span>
          <span style={{ fontSize: 10, color: 'black', marginLeft: 5 }}>
            <svg
              width="14"
              height="14"
              viewBox="0 0 20 20"
              style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: 6 }}
              aria-hidden="true"
              focusable="false"
            >
              <rect x="3" y="3" width="14" height="2" rx="3" fill="grey" stroke="grey" strokeWidth="0.6" />
            </svg>
            HEAVY_BUYER_DETECTED ({heavyBuying.length})
          </span>
          <span style={{ fontSize: 10, color: 'black', marginLeft: 5 }}>
            <svg
              width="14"
              height="14"
              viewBox="0 0 20 20"
              style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: 6 }}
              aria-hidden="true"
              focusable="false"
            >
              <rect x="3" y="3" width="14" height="2" rx="3" fill="grey" stroke="grey" strokeWidth="0.6" />
            </svg>
            HEAVY_SELLER_DETECTED ({heavySelling.length})
          </span>

           <span style={{ fontSize: 10, color: 'black', marginLeft: 5 }}>
            <svg width="14" height="14" viewBox="0 0 20 20" 
            style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: 6 }} 
            aria-hidden="true" 
            focusable="false">
              <circle cx="10" cy="10" r="5" fill="grey" />
            </svg>
            CANDLE_CLOSED_BELOW_BBLOWER ({candleCloseBelowBBLower.length})
          </span>
         
         
          <div style={{ height: 800, width: '98%', margin: 20, alignContent: 'center', justifyContent: 'center', padding: 25 }}>


            <ResponsiveContainer>

              <ScatterChart>
                <CartesianGrid stroke="#d4d3d3ff" strokeDasharray="1 1" />
                <XAxis
                  type="number"
                  dataKey="x"
                  name="Time"
                  domain={['dataMin', 'dataMax']}
                  tickFormatter={(ts) => new Date(ts).toLocaleString()}
                />
                <YAxis type="number" dataKey="y" name="Price" />
                <Tooltip content={<TooltipBox />} cursor={{ strokeDasharray: '3 3' }} />
                <Scatter
                  name="Whale Accumulation"
                  data={whaleAccumulationData}
                  shape={renderWhale}
                />
                <Scatter
                  name="FVG Data"
                  data={fvgData}
                  shape={renderFVG}
                />
                <Scatter
                  name="BBGap Data Lowest"
                  data={bbDataLowest}
                  shape={renderBBGapLowest}
                />
                <Scatter
                  name="BBGap Data Highest"
                  data={bbDataHighest}
                  shape={renderBBGapHighest}
                />
                 <Scatter
                  name="Heavy Buying"
                  data={heavyBuying}
                  shape={renderHeavyBuying}
                />
                <Scatter
                  name="Heavy Selling"
                  data={heavySelling}
                  shape={renderHeavySelling}
                />
                 <Scatter
                  name="Candle Closed Below BB Lower"
                  data={candleCloseBelowBBLower}
                  shape={renderCandleCloseBelowBBLower}
                />
              </ScatterChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
    </div>
  ) : null;

};


export default Symbols;
